module.exports = __webpack_public_path__ + "static/img/ys-02.2ab8652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ys-02.jpg
// module id = Dn7H
// module chunks = 1